import { sanitizeGrowthBrowserEvent } from '../supabase/functions/_shared/growth/analytics-schema';
import { filterPosthogEvent, posthogVolumeOptions } from './lib/posthogPolicy';
import { PostHogProvider } from 'posthog-js/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

window.addEventListener('vite:preloadError', (event) => {
  console.log('Vite preload error:', event);
  event.preventDefault()
  window.location.reload()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_API_HOST,
        ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST,
        defaults: '2026-01-30',
        disable_surveys: window.location.pathname === '/lt-checkout',
        disable_surveys_automatic_display: window.location.pathname === '/lt-checkout',
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
        ...posthogVolumeOptions,
        capture_pageview: 'history_change',
        // Session replay is useful inside the product, but its recorder is a
        // large, non-critical download on the public pricing route.
        disable_session_recording: window.location.pathname === '/pricing' || window.location.pathname.startsWith('/growth-autopilot'),
        opt_out_capturing_by_default: !import.meta.env.PROD && import.meta.env.VITE_POSTHOG_DEBUG !== 'true',
        before_send: (event) => sanitizeGrowthBrowserEvent(filterPosthogEvent(event), window.location.pathname),
        debug: false, //import.meta.env.MODE === 'development',
        session_recording: {
          blockSelector: '[data-growth-private]',
          maskAllInputs: true,
          maskInputOptions: {
            password: true
          }
        },
        __preview_deferred_init_extensions: true,
      }}
    >
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </PostHogProvider>
  </StrictMode>
);
